export default __webpack_public_path__ + "static/media/q8_step4.f8154f81.png";